import { render, staticRenderFns } from "./Project16Zh.vue?vue&type=template&id=fbe72342&scoped=true&"
import script from "./Project16Zh.vue?vue&type=script&lang=js&"
export * from "./Project16Zh.vue?vue&type=script&lang=js&"
import style0 from "./Project16Zh.vue?vue&type=style&index=0&id=fbe72342&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe72342",
  null
  
)

export default component.exports